import dayjs from 'dayjs';
import { EffectReducer } from 'use-effect-reducer';
import { Airport } from '../InteractiveMapContainer/filters/useLocations';

export interface FiltersState {
  originDestinationLogic: string;
  origin: Partial<Airport>;
  destination: Partial<Airport>;
  dateRange: any;
  budget: string | null;
  travelClass: string;
  sorting: string;
  flightType: string;
  flightStopCount: string;
  formPrepopuled: boolean;
  userInteraction?: boolean;
  airlines?: any;
  travelerInterest?: $TSFixMe;
  histogramType?: string;
  noClearDestination?: boolean;
  navigation?: string;
  isFullMode?: boolean;
  passengers?: any;
}

export const filtersReducer: EffectReducer<FiltersState, any, any> = (state, action, exec) => {
  exec({ type: 'tracking', action, prevState: state });
  if (action.category !== 'tracking') {
    switch (action.type) {
      case 'NAVIGATION_CHANGE': {
        return {
          ...state,
          navigation: action.payload
        };
      }
      case 'FULL_MODE': {
        return {
          ...state,
          isFullMode: action.payload
        };
      }
      case 'MONTH_CHANGE_HISTOGRAM': {
        return {
          ...state,
          dateRange: {
            start: action.payload.start,
            end: action.payload.end,
            selected: action.payload.selected
          }
        };
      }
      case 'MONTH_CHANGE':
      case 'DATE_RANGE_CHANGE': {
        return {
          ...state,
          dateRange: action.payload
        };
      }
      case 'DATE_RANGE_CLEAR': {
        return {
          ...state,
          dateRange: {}
        };
      }
      case 'DATE_RANGE_HISTOGRAM_CHANGE': {
        return {
          ...state,
          dateRange: action.payload.dateRange,
          histogramType: action.payload.histogramType
        };
      }
      case 'DATE_RANGE_HISTOGRAM_TYPE_CHANGE': {
        return {
          ...state,
          histogramType: action.payload.histogramType
        };
      }
      case 'BUDGET_CHANGE': {
        return {
          ...state,
          budget: action.payload
        };
      }
      case 'BUDGET_CLEAR': {
        return {
          ...state,
          budget: null
        };
      }
      case 'FULLY_VACCINATED_CHANGE': {
        return {
          ...state,
          fullyVaccinated: action.payload
        };
      }
      case 'FLIGHT_TYPE_CHANGE': {
        return {
          ...state,
          flightType: action.payload,
          dateRange:
            state.histogramType !== null && state.histogramType !== undefined
              ? {
                  ...state.dateRange,
                  start:
                    dayjs(state?.dateRange?.start).get('month') === dayjs(new Date()).get('month')
                      ? new Date()
                      : dayjs(state?.dateRange?.start).set('date', 1).toDate()
                }
              : state.dateRange,
          histogramType:
            state.histogramType !== null && state.histogramType !== undefined
              ? ''
              : state.histogramType
        };
      }
      case 'TRIP_DURATION_CHANGE': {
        return {
          ...state,
          tripDuration: action.payload
        };
      }
      case 'NUMBER_STOPS_CHANGE': {
        return {
          ...state,
          flightStopCount: action.payload
        };
      }
      case 'RATING_CHANGE': {
        return {
          ...state,
          rating: action.payload
        };
      }
      case 'SORTING_CHANGE': {
        return {
          ...state,
          sorting: action.payload.value
        };
      }
      case 'TRAVEL_CLASS_CHANGE': {
        return {
          ...state,
          travelClass: action.payload
        };
      }
      case 'TRAVEL_CLASS_CHANGE_NO_TRACKING': {
        return {
          ...state,
          travelClass: action.payload
        };
      }
      case 'AIRLINES_CHANGE': {
        return {
          ...state,
          airlines: action.payload
        };
      }
      case 'TRAVELER_CHANGE': {
        return {
          ...state,
          travelerInterest: {
            ...state.travelerInterest,
            ...action.payload
          }
        };
      }
      case 'TRAVELER_CLEAR': {
        const travelerInterest = {
          ...state.travelerInterest
        };
        delete travelerInterest[action.payload];
        return {
          ...state,
          travelerInterest
        };
      }
      case 'ORIGIN_CHANGE': {
        const originValue = action.payload || {};
        let destinationValue = state.destination;

        if (destinationValue.value === originValue.value) {
          destinationValue = {};
        }

        let newReturn = {
          ...state,
          origin: originValue,
          destination: destinationValue,
          userInteraction: true,
          airlines: originValue.value !== '' && destinationValue.value !== '' ? undefined : null,
          dateRange:
            state.histogramType !== null && state.histogramType !== undefined
              ? {
                  start: dayjs().toDate(),
                  end: dayjs().endOf('month').toDate()
                }
              : state.dateRange
        };
        if (state.histogramType !== null && state.histogramType !== undefined) {
          newReturn['histogramType'] = '';
        }
        return newReturn;
      }
      case 'ORIGIN_CLEAR': {
        let newReturn = {
          ...state,
          origin: {},
          destination: state.noClearDestination ? { ...state.destination } : {},
          airlines: undefined,
          dateRange:
            state.histogramType !== null && state.histogramType !== undefined
              ? {
                  start: dayjs().toDate(),
                  end: dayjs().endOf('month').toDate()
                }
              : state.dateRange
        };
        if (state.histogramType !== null && state.histogramType !== undefined) {
          newReturn['histogramType'] = '';
        }
        return newReturn;
      }
      case 'DESTINATION_CHANGE': {
        const destinationValue = action.payload || {};
        let originValue = state.origin;
        if (destinationValue.value === originValue.value) {
          originValue = {};
        }
        let newReturn = {
          ...state,
          destination: destinationValue,
          origin: originValue,
          userInteraction: true,
          airlines: originValue.value !== '' && destinationValue.value !== '' ? undefined : null,
          dateRange:
            state.histogramType !== null && state.histogramType !== undefined
              ? {
                  start: dayjs().toDate(),
                  end: dayjs().endOf('month').toDate()
                }
              : state.dateRange
        };

        if (state.histogramType !== null && state.histogramType !== undefined) {
          newReturn['histogramType'] = '';
        }

        return newReturn;
      }
      case 'DESTINATION_CLEAR': {
        let newReturn = {
          ...state,
          destination: {},
          airlines: undefined,
          dateRange:
            state.histogramType !== null && state.histogramType !== undefined
              ? {
                  start: dayjs().toDate(),
                  end: dayjs().endOf('month').toDate()
                }
              : state.dateRange
        };

        if (state.histogramType !== null && state.histogramType !== undefined) {
          newReturn['histogramType'] = '';
        }
        return newReturn;
      }
      case 'SWAP_LOCATIONS': {
        return {
          ...state,
          origin: state.destination,
          destination: state.origin
        };
      }
      case 'CLEAR_ALL': {
        return {
          ...state,
          origin: {},
          destination: {},
          dateRange: {},
          budget: null,
          airlines: undefined,
          tripDuration: undefined,
          rating: undefined,
          travelerInterest: {},
          ...action.payload
        };
      }
      case 'CLEAR_PARTIAL': {
        return {
          ...state,
          ...action.payload
        };
      }
      case 'SET_ALL': {
        return {
          ...state,
          ...action.payload
        };
      }
      case 'SET_USER_INTERACTION': {
        return {
          ...state,
          userInteraction: true
        };
      }
      case 'PASSENGERS_CHANGE': {
        return {
          ...state,
          passengers: action.payload
        };
      }
    }
  }
  return state;
};
